<template>
  <el-container class="energy-price" direction="vertical">
    <common-panel :panel-data="panelData"/>
  </el-container>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";

export default {
  name: "EnergyPrice",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        tableTitle: '单价列表',
        hasTree: false,
        hasMenu: true,
        energyItem: [{'id': '1', 'name': '电'}],
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getEnergyPrice,
        filterForm: [
          {label: '站点名称：', prop: 'siteName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '设置单价', icon: 'zy-icon-setting-gear', type: 'updateRows', handleIndex: 1}
        ],
        methods: {
          edit: this.$api.systemManage.updateEnergyPrice,
          update_prop: 'id'
        },
        tableCheck: true,
        tableProps: [
          {prop: "siteName", label: "站点名称"},
          {prop: "transPrice", label: "输配电价"},
          {prop: "netPrice", label: "上网电价"},
          {prop: "tipRate", label: "尖时段倍率"},
          {prop: "topRate", label: "峰时段倍率"},
          {prop: "normRate", label: "平时段倍率"},
          {prop: "botRate", label: "谷时段倍率"},
          {prop: "levyPrice", label: "代征电价"},
          {prop: "totalPrice", label: "容量单价"},
          {prop: "demandPrice", label: "需量单价"}
        ],
        drawerTitle: '单价信息',
        dialogs: {
          add_edit: {
            title: '单价信息',
            width: '700px',
            items: [
              {type: 'input', prop: 'transPrice', label: '输配电价：', placeholder: '请输入输配电价', style: 'width: 315px;'},
              {type: 'input', prop: 'netPrice', label: '上网电价：', placeholder: '请输入上网电价', style: 'width: 315px;'},
              {type: 'input', prop: 'tipRate', label: '尖时段倍率：', placeholder: '请输入尖时段倍率', style: 'width: 315px;'},
              {type: 'input', prop: 'topRate', label: '峰时段倍率：', placeholder: '请输入峰时段倍率', style: 'width: 315px;'},
              {type: 'input', prop: 'normRate', label: '平时段倍率：', placeholder: '请输入平时段倍率', style: 'width: 315px;'},
              {type: 'input', prop: 'botRate', label: '谷时段倍率：', placeholder: '请输入谷时段倍率', style: 'width: 315px;'},
              {type: 'input', prop: 'levyPrice', label: '代征电价：', placeholder: '请输入代征电价', style: 'width: 315px;'},
              {type: 'input', prop: 'totalPrice', label: '容量单价：', placeholder: '请输入容量单价', style: 'width: 315px;'},
              {type: 'input', prop: 'demandPrice', label: '需量单价：', placeholder: '请输入需量单价', style: 'width: 315px;'}
            ],
            rules: {
              transPrice: [
                {required: true, message: '请输入输配电价', trigger: 'blur'}
              ],
              netPrice: [
                {required: true, message: '请输入上网电价', trigger: 'blur'}
              ],
              tipRate: [
                {required: true, message: '请输入尖时段倍率', trigger: 'blur'}
              ],
              topRate: [
                {required: true, message: '请输入峰时段倍率', trigger: 'blur'}
              ],
              normRate: [
                {required: true, message: '请输入平时段倍率', trigger: 'blur'}
              ],
              botRate: [
                {required: true, message: '请输入谷时段倍率', trigger: 'blur'}
              ],
              levyPrice: [
                {required: true, message: '请输入代征电价', trigger: 'blur'}
              ]
            },
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.energy-price{
  width: 100%;
  height: 100%;
}
.el-menu{
  background: white;
}
.el-menu .el-menu-item{
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/EnergyPrice.vue